import { Layout, Form, FormField, Input, DatePicker } from '@vwfs-bronson/bronson-react';

import moment from 'moment';
import 'moment/locale/es';

const region = 'es';
moment.locale(region);

export const ClientInfo = ({
  formValues,
  fieldErrors,
  handleFieldChange,
  commitDateField,
  formType,
  layoutSize = '1/3',
}) => {
  return (
    <Form floatingLabel>
      <Layout>
        <Layout.Item default={layoutSize} xs="1/1">
          <FormField labelForId={`NIF-${formType}`} labelText="NIF/NIE*" type="input" noFloatingLabel>
            <Input
              id={`NIF-${formType}`}
              name="NIF"
              autoComplete="nope"
              value={(formValues.NIF ?? '').toUpperCase()}
              error={fieldErrors.NIF}
              style={{ textTransform: 'uppercase' }}
              onChange={handleFieldChange}
            />
          </FormField>
        </Layout.Item>

        <Layout.Item default={layoutSize} m="1/2" xs="1/1">
          <FormField labelForId={`FechaNacimiento-${formType}`} labelText="Fecha de Nacimiento*" type="other">
            <DatePicker
              flatpickrOptions={{
                static: true,
                allowInput: true,

                onClose: (selectedDates, dateStr, instance) => {
                  commitDateField('FechaNacimiento', instance.input.value);
                },
              }}
              dateFormat="d/m/Y"
              id={`FechaNacimiento-${formType}`}
              name="FechaNacimiento"
              autoComplete="nope"
              error={fieldErrors.FechaNacimiento}
              value={formValues.FechaNacimiento}
              onChange={(value) => {
                commitDateField('FechaNacimiento', value);
              }}
              locale={region}
            />
          </FormField>
        </Layout.Item>

        <Layout.Item default={layoutSize} m="1/2" xs="1/1">
          <FormField labelForId={`FechaCarnet-${formType}`} labelText="Fecha de Carnet*" type="other">
            <DatePicker
              flatpickrOptions={{
                static: true,
                allowInput: true,

                onClose: (selectedDates, dateStr, instance) => {
                  commitDateField('FechaCarne', instance.input.value);
                },
              }}
              dateFormat="d/m/Y"
              //maxDate={moment().toDate()}
              id={`FechaCarnet-${formType}`}
              name="FechaCarne"
              autoComplete="nope"
              error={fieldErrors.FechaCarne}
              value={formValues.FechaCarne}
              onChange={(value) => {
                commitDateField('FechaCarne', value);
              }}
              locale={region}
            />
          </FormField>
        </Layout.Item>

        <Layout.Item default={layoutSize} m="1/2" xs="1/1">
          <FormField labelForId={`CodigoPostal-${formType}`} labelText="Código Postal*" type="input" noFloatingLabel>
            <Input
              id={`CodigoPostal-${formType}`}
              name="CodigoPostal"
              value={formValues.CodigoPostal}
              error={fieldErrors.CodigoPostal}
              onChange={handleFieldChange}
            />
          </FormField>
        </Layout.Item>
        <Layout.Item default={layoutSize} m="1/2" xs="1/1">
          <FormField labelForId={`Provincia-${formType}`} labelText="Provincia*" type="input" noFloatingLabel>
            <Input id={`Provincia-${formType}`} name="Provincia" value={formValues.Provincia} readOnly />
          </FormField>
        </Layout.Item>
        <Layout.Item default={layoutSize} m="1/2" xs="1/1">
          <FormField labelForId={`Poblacion-${formType}`} labelText="Población*" type="input" noFloatingLabel>
            <Input id={`Poblacion-${formType}`} name="Poblacion" value={formValues.Poblacion} readOnly />
          </FormField>
        </Layout.Item>
      </Layout>
    </Form>
  );
};
